(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ari-new-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function collectSections(scope) {
      const root = scope || document;
      const sections = Array.prototype.slice.call(root.querySelectorAll('.ari-new-collection[data-section-id]'));
      if (root.matches && root.matches('.ari-new-collection[data-section-id]')) {
        sections.unshift(root);
      }
      return sections;
    }

    function initBuTabs(root) {
      collectSections(root).forEach(function (section) {
        if (section.__ariBuTabsInit) return;
        section.__ariBuTabsInit = true;

        const tabList = section.querySelector('.ari-new-collection__bu-tabs');
        const tabs = Array.prototype.slice.call(section.querySelectorAll('[data-bu-tab]'));
        const panels = section.querySelectorAll('[data-bu-panel]');

        if (!tabs.length || !panels.length) return;

        function setActiveTab(key, options) {
          let activeTab = null;
          tabs.forEach(function (tab) {
            const isActive = tab.dataset.buTab === key;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
            tab.tabIndex = isActive ? 0 : -1;
            if (isActive) activeTab = tab;
          });

          panels.forEach(function (panel) {
            const isActive = panel.dataset.buPanel === key;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
          });

          const viewAll = section.querySelector('.ari-new-collection__view-all');
          if (viewAll && activeTab) {
            const url = activeTab.getAttribute('data-collection-url');
            if (url) {
              viewAll.href = url;
              viewAll.hidden = false;
            } else {
              viewAll.hidden = true;
            }
          }

          if (activeTab && tabList && options && options.scroll) {
            activeTab.scrollIntoView({ inline: 'nearest', block: 'nearest' });
          }

          window.requestAnimationFrame(function () {
            const panel = section.querySelector('[data-bu-panel="' + key + '"]');
            if (!panel) return;
            panel.querySelectorAll('swiper-container').forEach(function (el) {
              if (el.swiper && typeof el.swiper.update === 'function') el.swiper.update();
            });
            window.dispatchEvent(new Event('resize'));
          });
        }

        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            setActiveTab(tab.dataset.buTab, { scroll: true });
          });
        });

        if (tabList) {
          tabList.addEventListener('keydown', function (event) {
            const key = event.key;
            if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End') return;
            const currentIndex = tabs.indexOf(document.activeElement);
            let index = currentIndex >= 0 ? currentIndex : tabs.findIndex(function (tab) {
              return tab.classList.contains('is-active');
            });
            if (index < 0) index = 0;
            if (key === 'ArrowRight') index = (index + 1) % tabs.length;
            else if (key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
            else if (key === 'Home') index = 0;
            else index = tabs.length - 1;
            event.preventDefault();
            setActiveTab(tabs[index].dataset.buTab, { scroll: true });
            tabs[index].focus();
          });
        }

        const defaultTab = section.querySelector('[data-bu-tab].is-active') || tabs[0];
        if (defaultTab) setActiveTab(defaultTab.dataset.buTab);
      });
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    function parseDate(value) {
      if (!value) return null;
      var v = String(value).trim();
      if (!v) return null;
      v = v.replace(' ', 'T');
      if (/^\d{4}-\d{2}-\d{2}$/.test(v)) v += 'T00:00:00';
      if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(v)) v += ':00';
      var d = new Date(v);
      return isNaN(d.getTime()) ? null : d;
    }

    function initCountdown(el) {
      if (el.__ariCountdownInit) return;
      el.__ariCountdownInit = true;

      var start = parseDate(el.dataset.startDate);
      var end = parseDate(el.dataset.endDate);
      if (!end) { el.style.display = 'none'; return; }

      var nodes = {
        days: el.querySelector('[data-unit="days"]'),
        hours: el.querySelector('[data-unit="hours"]'),
        minutes: el.querySelector('[data-unit="minutes"]'),
        seconds: el.querySelector('[data-unit="seconds"]')
      };
      var prev = { days: null, hours: null, minutes: null, seconds: null };

      function setValue(unit, val) {
        var node = nodes[unit];
        if (!node) return;
        var str = pad(val);
        if (prev[unit] === str) return;
        node.textContent = str;
        node.classList.remove('is-tick');
        void node.offsetWidth;
        node.classList.add('is-tick');
        prev[unit] = str;
      }

      function zeroOut() {
        setValue('days', 0);
        setValue('hours', 0);
        setValue('minutes', 0);
        setValue('seconds', 0);
      }

      function tick() {
        var now = new Date();
        if (start && now < start) {
          el.classList.add('is-not-started');
          el.classList.remove('is-active', 'is-ended', 'is-urgent');
          zeroOut();
          return;
        }
        el.classList.remove('is-not-started');

        var diff = end.getTime() - now.getTime();
        if (diff <= 0) {
          el.classList.add('is-ended');
          el.classList.remove('is-active', 'is-urgent');
          zeroOut();
          if (el.__ariCountdownTimer) {
            clearInterval(el.__ariCountdownTimer);
            el.__ariCountdownTimer = null;
          }
          return;
        }

        el.classList.add('is-active');
        el.classList.toggle('is-urgent', diff < 60 * 60 * 1000);

        var s = Math.floor(diff / 1000);
        var days = Math.floor(s / 86400); s -= days * 86400;
        var hours = Math.floor(s / 3600); s -= hours * 3600;
        var minutes = Math.floor(s / 60); s -= minutes * 60;
        setValue('days', days);
        setValue('hours', hours);
        setValue('minutes', minutes);
        setValue('seconds', s);
      }

      tick();
      el.__ariCountdownTimer = setInterval(tick, 1000);
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-ari-countdown]').forEach(initCountdown);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initBuTabs();
        initAll();
      });
    } else {
      initBuTabs();
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initBuTabs(e.target);
      initAll(e.target);
    });
    document.addEventListener('shopify:block:select', function (e) {
      const panel = e.target.closest('[data-bu-panel]');
      if (!panel) return;
      const section = panel.closest('.ari-new-collection');
      if (!section) return;
      initBuTabs(section);
      const tab = section.querySelector('[data-bu-tab="' + panel.dataset.buPanel + '"]');
      if (tab) tab.click();
    });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-ari-countdown]').forEach(function (el) {
        if (el.__ariCountdownTimer) clearInterval(el.__ariCountdownTimer);
        el.__ariCountdownInit = false;
        el.__ariCountdownTimer = null;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-utility-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    const backToTopButtons = document.querySelectorAll('[data-back-to-top]');
    
    backToTopButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        if (!('scrollBehavior' in document.documentElement.style)) {
          scrollToTopFallback();
        }
      });
    });

    function scrollToTopFallback() {
      var currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentPosition > 0) {
        window.requestAnimationFrame(scrollToTopFallback);
        window.scrollTo(0, currentPosition - currentPosition / 8);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function onReady(fn) {
      if (document.readyState != 'loading') return fn();
      document.addEventListener('DOMContentLoaded', fn);
    }
    onReady(function () {
      // --- Mobile search overlay (independent of mega drawer) ---
      const mobileSearchIcon = document.querySelector('.mobile-header-search-icon');

      function openMobileSearch() {
        if (typeof window.ariOpenMobileSearchOverlay === 'function') {
          window.ariOpenMobileSearchOverlay('header-icon');
        }
      }

      if (mobileSearchIcon) {
        mobileSearchIcon.addEventListener('click', function () {
          openMobileSearch();
        });
      }

      // --- Drawer Toggle ---
      const drawer = document.getElementById('mega-drawer');
      if (!drawer) return;

      const openBtn = document.querySelector('.header__icon--menu');
      const backdrop = drawer.querySelector('.mega-drawer__backdrop');
      const header = document.querySelector('header .main-header');
      const headerRow = document.querySelector('header .main-header .section:not(.bu-tabs)');
      const headerComponent = document.querySelector('header-component');
      let drawerOffsetRaf = null;
      let drawerOffsetResizeObserver = null;
      let drawerOffsetMutationObserver = null;
      const drawerOffsetEvents = ['resize', 'scroll'];

      function getElementBottom(element) {
        if (!(element instanceof HTMLElement)) return 0;
        const rect = element.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return 0;
        return Math.max(0, rect.bottom);
      }

      function shouldUseTopOverlay(element) {
        if (!(element instanceof HTMLElement)) return false;
        if (drawer.contains(element) || element.closest('#mega-drawer, #mobile-search-overlay')) return false;
        if (headerComponent && headerComponent.contains(element)) return false;

        const rect = element.getBoundingClientRect();
        if (rect.width < window.innerWidth * 0.5 || rect.height <= 0 || rect.height > 220) return false;
        if (rect.bottom <= 0 || rect.top > 4) return false;

        const position = window.getComputedStyle(element).position;
        return position === 'fixed' || position === 'sticky';
      }

      function getTopOverlayBottom() {
        const sampleX = Math.max(1, Math.floor(window.innerWidth / 2));
        const sampleYValues = [1, 16, 32, 48, 64, 96, 128, 160, 200];
        let overlayBottom = 0;

        sampleYValues.forEach(function (sampleY) {
          if (sampleY >= window.innerHeight) return;
          const elements = document.elementsFromPoint(sampleX, sampleY);
          elements.forEach(function (element) {
            let current = element;
            while (current && current !== document.body) {
              if (shouldUseTopOverlay(current)) {
                overlayBottom = Math.max(overlayBottom, current.getBoundingClientRect().bottom);
                break;
              }
              current = current.parentElement;
            }
          });
        });

        return overlayBottom;
      }

      function calculateDrawerOffset() {
        const headerRowBottom = getElementBottom(headerRow);
        const headerBottom = getElementBottom(headerComponent);
        const visibleHeaderBottom = headerRowBottom || headerBottom;
        const topOverlayBottom = getTopOverlayBottom();

        return Math.ceil(Math.max(visibleHeaderBottom, topOverlayBottom));
      }

      function syncDrawerOffset() {
        if (drawerOffsetRaf) return;

        drawerOffsetRaf = requestAnimationFrame(function () {
          drawerOffsetRaf = null;
          setDrawerOffset();
        });
      }

      function setDrawerOffset() {
        drawer.style.setProperty('--mega-drawer-offset', calculateDrawerOffset() + 'px');
      }

      function observeDrawerOffsetElements() {
        if (!drawerOffsetResizeObserver) return;

        [document.body, headerComponent, headerRow].forEach(function (element) {
          if (element instanceof HTMLElement) drawerOffsetResizeObserver.observe(element);
        });

        Array.from(document.body.children).forEach(function (element) {
          if (element instanceof HTMLElement) drawerOffsetResizeObserver.observe(element);
        });
      }

      function startDrawerOffsetSync() {
        syncDrawerOffset();

        drawerOffsetEvents.forEach(function (eventName) {
          window.addEventListener(eventName, syncDrawerOffset, { passive: true });
        });

        if (!drawerOffsetResizeObserver) {
          drawerOffsetResizeObserver = new ResizeObserver(syncDrawerOffset);
        }
        observeDrawerOffsetElements();

        if (!drawerOffsetMutationObserver) {
          drawerOffsetMutationObserver = new MutationObserver(function () {
            observeDrawerOffsetElements();
            syncDrawerOffset();
          });
          drawerOffsetMutationObserver.observe(document.body, {
            attributes: true,
            attributeFilter: ['class', 'style', 'hidden'],
            childList: true,
            subtree: true,
          });
        }
      }

      function stopDrawerOffsetSync() {
        drawerOffsetEvents.forEach(function (eventName) {
          window.removeEventListener(eventName, syncDrawerOffset);
        });
        drawerOffsetResizeObserver?.disconnect();
        drawerOffsetMutationObserver?.disconnect();
        drawerOffsetResizeObserver = null;
        drawerOffsetMutationObserver = null;
        if (drawerOffsetRaf) {
          cancelAnimationFrame(drawerOffsetRaf);
          drawerOffsetRaf = null;
        }
      }

      function openDrawer() {
        openBtn.classList.add('is-active')
        header.classList.add('menu-open');
        setDrawerOffset();
        drawer.classList.add('is-open');
        startDrawerOffsetSync();

        headerRow.classList.add('color-scheme-1');
        headerRow.classList.remove('color-scheme-5');
        const images = document.querySelectorAll('.logo-link img');
        if (images.length > 1) images.forEach(img => img.classList.toggle('hidden'));
        document.querySelectorAll('.header__icon--menu .svg-wrapper').forEach(svg => svg.classList.toggle('hidden'));
        document.body.style.overflow = 'hidden';
      }

      function closeDrawer() {
        drawer.classList.remove('is-open');
        stopDrawerOffsetSync();
        document.body.style.overflow = '';
        document.querySelector('header .main-header').classList.remove('menu-open');

        headerRow.classList.remove('color-scheme-1');
        headerRow.classList.add('color-scheme-5');
        const images = document.querySelectorAll('.logo-link img');
        if (images.length > 1) images.forEach(img => img.classList.toggle('hidden'));    
        document.querySelectorAll('.header__icon--menu .svg-wrapper').forEach(svg => svg.classList.toggle('hidden'));

        openBtn.classList.remove('is-active')

        // Reset nav to level 0 when closing for next time
        setTimeout(() => {
          const mobileNav = drawer.querySelector('.mobile-nav');
          if (mobileNav) {
            const allPanels = mobileNav.querySelectorAll('.mobile-nav__panel');
            allPanels.forEach((p) => {
              p.classList.remove('is-visible', 'is-parent');
            });
            const level0Panel = mobileNav.querySelector('[data-level="0"]');
            if (level0Panel) {
              level0Panel.classList.add('is-visible');
            }
          }
        }, 350); // After transition ends
      }

      if (openBtn) {
        openBtn.addEventListener('click', () => {
          if (openBtn.classList.contains('is-active')) {
            closeDrawer();
          } else {
            openDrawer();
          }
        });
      }

      if (backdrop) backdrop.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
          closeDrawer();
        }
      });

      // --- Mobile Navigation Drill-down ---
      const mobileNav = drawer.querySelector('.mobile-nav');
      if (mobileNav) {
        drawer.addEventListener('click', function (e) {
          const expandBtn = e.target.closest('.mobile-nav__expand-btn.has-submenu');
          const backBtn = e.target.closest('.mobile-nav__back-btn');

          if (expandBtn) {
            e.preventDefault();
            const targetPanelId = expandBtn.dataset.targetPanel;
            const targetPanel = mobileNav.querySelector(`[data-panel-id="${targetPanelId}"]`);
            if (!targetPanel) return;

            const currentVisiblePanel = mobileNav.querySelector('.mobile-nav__panel.is-visible');
            if (currentVisiblePanel) {
              currentVisiblePanel.classList.remove('is-visible');
              currentVisiblePanel.classList.add('is-parent');
            }
            targetPanel.classList.add('is-visible');

            // Reset scroll of new panel
            const content = targetPanel.querySelector('.mobile-nav__panel-content');
            if (content) content.scrollTop = 0;
          }

          if (backBtn) {
            e.preventDefault();
            const targetPanelId = backBtn.dataset.targetPanel;
            const targetPanel = mobileNav.querySelector(`[data-panel-id="${targetPanelId}"]`);
            if (!targetPanel) return;

            const currentVisiblePanel = mobileNav.querySelector('.mobile-nav__panel.is-visible');
            if (currentVisiblePanel) {
              currentVisiblePanel.classList.remove('is-visible');
            }

            targetPanel.classList.remove('is-parent');
            targetPanel.classList.add('is-visible');

            // Reset scroll of returning panel
            const content = targetPanel.querySelector('.mobile-nav__panel-content');
            if (content) content.scrollTop = 0;
          }
        });
      }

    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
